/** @format */

const concerts = [
  // { name: "Maroon 5", date: new Date("2022/10/02"), id: 1 },
  { name: "Linkin Park", date: "2022-10-03", id: 2 },

  { name: "Ed Sheeran", date: "2022-10-04", id: 3 },
  { name: "Avril Lavigne", date: "2022-10-05", id: 4 },
  { name: "Adele", date: "2022-11-10", id: 5 },
  { name: "Whitney Houston", date: "2022-11-20", id: 6 },
  { name: "Ariana Grande", date: "2022-11-21", id: 7 },
  { name: "Luis Fonsi", date: "2022-11-22", id: 8 },
  { name: "Daddy Yankee", date: "2022-11-24", id: 9 },
  { name: "Enrique Iglesias", date: "2022-12-05", id: 10 },
  { name: "Selena Gomez", date: "2022-12-06", id: 11 },
];

export default concerts;
